"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/require-default-props */
var react_1 = __importStar(require("react"));
var date_fns_1 = require("date-fns");
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var moment_1 = __importDefault(require("moment"));
var style_1 = require("./style");
var dateList = [
    {
        label: "All Day",
        start: date_fns_1.startOfToday(),
        end: date_fns_1.startOfToday(),
    },
    {
        label: "All Week",
        start: date_fns_1.startOfWeek(new Date()),
        end: date_fns_1.endOfWeek(new Date()),
    },
    {
        label: "All Month",
        start: date_fns_1.startOfMonth(new Date()),
        end: date_fns_1.endOfMonth(new Date()),
    },
    {
        label: "All Year",
        start: date_fns_1.startOfYear(new Date()),
        end: date_fns_1.endOfYear(new Date()),
    },
    {
        label: "Custom",
        start: date_fns_1.startOfToday(),
        end: date_fns_1.startOfToday(),
    },
];
var FilterBar = function (_a) {
    var onChange = _a.onChange, _b = _a.canExpand, canExpand = _b === void 0 ? false : _b;
    var _c = react_1.useState({
        start: dateList[0].start,
        end: dateList[0].end,
    }), dateRange = _c[0], setDateRange = _c[1];
    var _d = react_1.useState(false), isOpen = _d[0], setIsOpen = _d[1];
    var toggleExpand = function () {
        setIsOpen(function (prev) { return !prev; });
    };
    var handleChangeDate = function (newDate, index) {
        setDateRange(newDate);
    };
    var handleResetDate = function () {
        setDateRange({
            start: dateList[0].start,
            end: dateList[0].end,
        });
    };
    var handleReset = function () {
        handleResetDate();
    };
    react_1.useEffect(function () {
        onChange([
            {
                key: "dateRange",
                value: dateRange,
            },
        ]);
    }, [onChange, dateRange]);
    return (react_1.default.createElement(style_1.FilterBarContainer, null,
        react_1.default.createElement(antd_1.Collapse, { ghost: true, activeKey: isOpen ? ["1"] : [] },
            react_1.default.createElement(style_1.DateFilterContainer, null,
                react_1.default.createElement(style_1.DateRow, null, dateList.map(function (_a, index, array) {
                    var start = _a.start, end = _a.end, label = _a.label;
                    var selected = dateRange.start === start && dateRange.end === end;
                    if (array.length - 1 === index) {
                        return (react_1.default.createElement(antd_1.DatePicker.RangePicker, { key: label, value: [moment_1.default(dateRange.start), moment_1.default(dateRange.end)], onChange: function (_, newDate) {
                                var newStart = newDate[0], newEnd = newDate[1];
                                if (newStart && newDate) {
                                    handleChangeDate({ start: new Date(newStart), end: new Date(newEnd) }, index);
                                }
                                else {
                                    handleResetDate();
                                }
                            } }));
                    }
                    return (react_1.default.createElement(antd_1.Button, { key: label, type: selected ? "primary" : "text", onClick: function () { return handleChangeDate({ start: start, end: end }, index); } }, label));
                })),
                react_1.default.createElement(antd_1.Button, { onClick: handleReset }, "Reset"),
                canExpand && (react_1.default.createElement(antd_1.Button, { type: "text", onClick: toggleExpand },
                    "Expand ",
                    react_1.default.createElement(icons_1.DownOutlined, null)))),
            react_1.default.createElement(style_1.StyledPanel, { showArrow: false, key: "1", header: "" }, "stsd"))));
};
exports.default = FilterBar;
